import { render, staticRenderFns } from "./ApproverTable.vue?vue&type=template&id=64c11c18"
import script from "./ApproverTable.vue?vue&type=script&lang=js"
export * from "./ApproverTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports